"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Group = require("./Group");

var _default = _Group.Group;
exports["default"] = _default;